import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an unhandled error:", error, errorInfo);
    this.setState({ errorInfo });
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    if (this.props.onReset) {
      this.props.onReset();
    } else {
      window.location.reload();
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="d-flex flex-column align-items-center justify-content-center p-4 text-center my-4"
          style={{ minHeight: "40vh" }}
        >
          <div
            className="p-4 rounded-4 shadow-sm bg-white border border-danger-subtle"
            style={{ maxWidth: "540px", width: "100%" }}
          >
            <div className="mb-3 text-danger">
              <AlertTriangle size={48} className="text-danger" />
            </div>
            <h4 className="fw-bold text-dark mb-2">Something went wrong</h4>
            <p className="text-muted small mb-4">
              An unexpected error occurred while rendering this section. You can
              retry loading this view.
            </p>
            {this.state.error?.message && (
              <div
                className="bg-light p-2 rounded text-start text-danger small font-monospace mb-4 overflow-auto"
                style={{ maxHeight: "100px" }}
              >
                {this.state.error.message}
              </div>
            )}
            <div className="d-flex justify-content-center gap-2">
              <button
                className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 fw-semibold"
                onClick={this.handleReset}
              >
                <RefreshCw size={16} />
                <span>Retry View</span>
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
